// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as bootstrap from "bootstrap"
import "./controllers"
import "./turbo_streams"


// MAKE BOOTSTRAP GLOBAL
window.bootstrap = bootstrap
